import { render, staticRenderFns } from "./approveFlow.vue?vue&type=template&id=420f822f&scoped=true&"
import script from "./approveFlow.vue?vue&type=script&lang=js&"
export * from "./approveFlow.vue?vue&type=script&lang=js&"
import style0 from "./approveFlow.vue?vue&type=style&index=0&id=420f822f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f822f",
  null
  
)

export default component.exports